/**
 * Created by Ram on 22/03/2017.
 */

import React from 'react';
import DevicesList from './CreateCluster/DevicesList';
import ClustersList from './AddDevicesToTest/ClustersList';
import SelectedDevicesList from './AddDevicesToTest/SelectedDevices';

class AddDevicesToTest extends React.Component {
    state = {
        isDisplayingClusters: false,
    };

    handleGetClusters = () => {
        this.props.getClusters();
        this.setState({ isDisplayingClusters: true });
    };

    handleGetDevices = () => {
        this.props.getDevices();
        this.setState({ isDisplayingClusters: false });
    };

    render() {
        const { isDisplayingClusters } = this.state;
        const { devices, clusters, selectedDevices, sortAsc, sort, sortLocal, sortLocalAsc } = this.props.loadData;
        const {
            updateSortState,
            updateDeviceList,
            getClusterDevices,
            removeCluster,
            removeDevice,
            sortLocalTable,
        } = this.props;

        let errorMessage = null,
            success = null,
            serverError = null;

        if (this.props.loadData.error) {
            errorMessage = <div className="alert alert-danger"> {this.props.loadData.error} </div>;
        }

        if (this.props.loadData.success) {
            success = (
                <h4 className="alert alert-success col-sm-10 col-sm-offset-1 text-center">
                    {this.props.loadData.success}
                </h4>
            );
        }

        if (this.props.loadData.serverError) {
            serverError = (
                <div className="alert alert-danger col-sm-4 col-sm-offset-4 text-center">
                    {' '}
                    {this.props.loadData.serverError}{' '}
                </div>
            );
        }

        return (
            <div>
                <ol className="breadcrumb">
                    <li>
                        <a onClick={this.props.navigator.requestTestInstanceManagement}>Test Instance Management</a>
                    </li>
                    <li>
                        <a onClick={this.props.handleSave}>
                            {this.props.loadData.testInstanceId ? 'Edit Test Instance' : 'New Test Instance'}
                        </a>
                    </li>
                    <li className="active">Add Devices to Test Instance</li>
                </ol>

                <div className="test-devices-main-div pull-left">
                    <div className="search-device-list">
                        <div className="row">
                            <div className="col-sm-4">
                                <span className="block-heading">
                                    {this.props.loadData.devicesClicked
                                        ? `Available Devices (${devices.length || 0})`
                                        : `Available Clusters (${clusters.length || 0})`}
                                </span>
                            </div>
                            <div className="col-sm-4" />
                            <div className="col-sm-4">
                                <input
                                    type="search"
                                    placeholder="Search..."
                                    className="form-control pull-left"
                                    onChange={this.props.updateSearchState}
                                    value={this.props.loadData.search}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="test-instance-devices-button">
                        <div className="row">
                            <div className="col-sm-9" />
                            <div className="col-sm-3">
                                <button
                                    type="button"
                                    className={`btn pull-left btn-primary ${isDisplayingClusters && 'active'}`}
                                    onClick={this.handleGetClusters}
                                >
                                    Clusters
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-primary pull-right  ${!isDisplayingClusters && 'active'}`}
                                    onClick={this.handleGetDevices}
                                >
                                    Devices
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="table registered-devices-list">
                        <div id="registered-device-list-main-table">
                            {isDisplayingClusters ? (
                                <ClustersList
                                    clusters={clusters}
                                    onAdd={getClusterDevices}
                                    onRemove={removeCluster}
                                    selectedDevices={selectedDevices}
                                    onSort={updateSortState}
                                    sortBy={sort}
                                    isSortAsc={sortAsc}
                                />
                            ) : (
                                <DevicesList
                                    devices={devices}
                                    onSort={updateSortState}
                                    sortBy={sort}
                                    isSortAsc={sortAsc}
                                    onAdd={updateDeviceList}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className="test-devices-overview pull-right">
                    <div className="add-test-devices-list">
                        <h3>Devices on instance ({selectedDevices.length || 0})</h3>
                        {serverError}
                        {success}
                        <SelectedDevicesList
                            selectedDevices={selectedDevices}
                            onRemove={removeDevice}
                            onSort={sortLocalTable}
                            sortBy={sortLocal}
                            isSortAsc={sortLocalAsc}
                        />
                        {selectedDevices === 'selectedDevices' && errorMessage}
                        <button
                            type="button"
                            className="btn btn-primary pull-right mainDivSubmit"
                            onClick={this.props.handleSave}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        ); // return
    } // render
} // AddDevicesToTest

export default AddDevicesToTest;
